<template>
  <div tabindex="0" @blur="onBlur" @mousedown="handleMouseDown">
    <span @click="toggleDropdown">
      {{ selectedLabel }}
      <i class="mdi" :class="show ? 'mdi-menu-up' : 'mdi-menu-down'"></i>
    </span>
    <ul v-if="show">
      <li
        v-for="option in options"
        :key="option.value"
        @click.prevent.stop="e => toggleOption(e, option)">
        <label>
          <i
            class="mdi mdi-checkbox-marked"
            v-if="selecionados.includes(option.value)"></i>
          <i class="mdi mdi-checkbox-blank-outline" v-else></i>
          {{ option.label }}
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["value", "options"],
  data() {
    return {
      proxy: [],
      show: false,
      mouseDown: false,
    };
  },
  computed: {
    selecionados: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    selectedLabel() {
      if (this.value.length === 0) {
        return "Selecione";
      } else if (this.value.length === 1) {
        return "1 Selecionado";
      } else {
        return `${this.value.length} Selecionados`;
      }
    },
  },
  methods: {
    toggleDropdown() {
      this.show = !this.show;
    },
    toggleOption(e, option) {
      let value = this.proxy;
      if (value.includes(option.value)) {
        value = value.filter(v => v !== option.value);
      } else {
        value = [...value, option.value];
      }
      this.selecionados = value;
    },
    handleMouseDown() {
      this.mouseDown = true;
      setTimeout(() => {
        this.mouseDown = false;
      }, 0);
    },
    onBlur() {
      if (!this.mouseDown) {
        this.show = false;
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.proxy = value;
      },
    },
  },
};
</script>
<style lang="less" scoped>
div {
  position: relative;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2em 0.5em;
    border: 1px solid #dddbda;
    border-radius: 4px;
    margin-top: 0.5em;
    margin-bottom: 16px;

    i.mdi {
      font-size: 1.5em;
    }
  }
  ul {
    position: absolute;
    display: block;
    width: 100%;
    height: 200px;
    overflow-y: scroll;
    border: 1px solid #ccc;
    background-color: #fff;
    z-index: 999;
    li {
      label {
        display: flex;
        align-items: center;
        padding: 0.5em 1em;
        border-bottom: 1px solid #f6f6f6;
        cursor: pointer;
        i.mdi {
          font-size: 1.5em;
          color: #555;
          margin-right: 0.5em;
        }
        &:hover {
          background-color: #eee;
        }
      }
    }
  }
}
</style>
